export default {"src":"/_next/static/media/mastercard.de50583d.svg","height":108,"width":152,"blurWidth":0,"blurHeight":0};